import create from 'zustand';
import securitiesAPI from 'lib/api/securities';

interface RegistrationStatusSlice {
  data: Record<string, any>;
  isLoading: boolean;
  error: any;
  getRegistrationStatus: () => void;
}

const registrationStatusStore = create<RegistrationStatusSlice>((set, get) => ({
  data: {
    status: 0,
  },
  isLoading: false,
  error: null,
  getRegistrationStatus: async () => {
    set({ isLoading: true, error: null });

    try {
      const response = await securitiesAPI.getOAStatus();

      if (!response?.data) {
        set({ isLoading: false });
        throw new Error('Attempt to fetch oa status failed');
      }

      const { data, error } = response.data;

      if (error) {
        set({ isLoading: false, error });
        // Currently, the API for getting registration status returned as not found
        return;
      }

      set({ data, isLoading: false, error: null });
    } catch (error) {
      // Handle the error here
      if (error instanceof Error) {
        console.error('Error fetching OA status:', error.message);
        set({ isLoading: false, error: error.message });
        return;
      }

      console.error('Unknown error while fetching OA status');
    } finally {
      set({ isLoading: false });
    }
  },
}));

export default registrationStatusStore;
